// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function TotalDueAtActivation() {
   const state = useQuoteContext()
   const { getString } = state

   const displaySectionPermissions = state.featurePermissions['OneTimeTotals']

   if (!displaySectionPermissions.includes(state.user_role)) return null

   if (state.user_view == 'Internal' || state.totalDueAtActivation > 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getString('product.TotalDueAtActivation.Header.Title')}
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.totalDueAtActivation,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
